module.exports = "/*==========  Mobile First Method  ==========*/\r\n\r\n/* Custom, iPhone Retina */\r\n\r\n@media only screen and (min-width : 320px) {\r\n\r\n}\r\n\r\n/* Extra Small Devices, Phones */\r\n\r\n@media only screen and (min-width : 480px) {\r\n\r\n}\r\n\r\n/* Small Devices, Tablets */\r\n\r\n@media only screen and (min-width : 768px) {\r\n\r\n}\r\n\r\n/* Medium Devices, Desktops */\r\n\r\n@media only screen and (min-width : 992px) {\r\n\r\n}\r\n\r\n/* Large Devices, Wide Screens */\r\n\r\n@media only screen and (min-width : 1200px) {\r\n\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main